import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=36d7a34a"
import script from "./Cms.vue?vue&type=script&lang=js"
export * from "./Cms.vue?vue&type=script&lang=js"
import style0 from "./Cms.vue?vue&type=style&index=0&id=36d7a34a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports